import React, { useState, useEffect } from 'react';
import { Grid, Container } from '@material-ui/core';
import { string, bool, shape } from 'prop-types';
import SideHeading from '../../SideHeading';
import styles from './style.module.scss';
import Image from '../../Image';

const CaseHeroSection = ({
  title,
  heroImg,
  sideHeadingFirst,
  sideHeadingSecond,
  smallerTitle,
  alignImage,
  centerHeroTitle,
  coverHero,
  color,
}) => {
  const [isTablet, setIsTablet] = useState(false);

  const resize = () => {
    if (window !== 'undefined') {
      setIsTablet(window.innerWidth < 959);
    }
  };

  useEffect(() => {
    if (window) {
      window.addEventListener('resize', resize);
      setIsTablet(window.innerWidth < 959);
    }
    return () => {
      window.removeEventListener('resize', resize);
    };
  }, []);

  const renderGrid = () => (
    <Grid
      container
      direction="column"
      className={styles.container}
    >
      <Grid item>
        <h1 className={[
          styles.title,
          smallerTitle && styles.titleSmaller,
          centerHeroTitle && styles.titleCenter,
        ].join(' ')}
        >
          {title}
        </h1>
      </Grid>
      <Grid item>
        <Grid container style={{ position: 'relative' }}>
          <Grid item xs>
            <Grid
              container
              className={styles.containerImage}
              style={{ backgroundColor: color }}
              alignItems={alignImage === 'right' ? 'center' : alignImage}
              justify="center"
            >
              { heroImg && (
              <Image
                source={heroImg}
                alt="hero case logo"
                className={[
                  styles.image,
                  alignImage === 'flex-end' && styles.imageEnd,
                  alignImage === 'center' && styles.imageCenter,
                  alignImage === 'right' && styles.imageRight,
                  coverHero && styles.imageCover,
                ].join(' ')}
              />
              )
                }
            </Grid>
          </Grid>
          <SideHeading
            firstHeading={sideHeadingFirst}
            secondHeading={sideHeadingSecond}
            className={styles.sideHeadingHero}
          />
        </Grid>
      </Grid>
    </Grid>
  );

  return isTablet ? renderGrid() : (
    <Container>
      {renderGrid()}
    </Container>
  );
};

CaseHeroSection.propTypes = {
  title: string,
  heroImg: shape({
    main: string,
    fall: string,
  }),
  sideHeadingFirst: string,
  sideHeadingSecond: string,
  color: string,
  smallerTitle: bool,
  alignImage: string,
  centerHeroTitle: bool,
};

CaseHeroSection.defaultProps = {
  title: '',
  heroImg: null,
  sideHeadingFirst: '',
  sideHeadingSecond: '',
  color: null,
  smallerTitle: false,
  alignImage: 'flex-end',
  centerHeroTitle: false,
};

export default CaseHeroSection;
